import React, { lazy, Suspense } from "react";
import { Link } from "react-router-dom";
//css
import "../../Styles/Category.css";
import useWindowsSize from "../../Hooks/useWindowsSize";
import useDessableZoom from "@/Hooks/useDesableZoom";
import {
  HeaderCategoryWeb,
  HeaderCategoryMovil,
  LogoIconNombreSVG,
  BtnLink,
  ImagesArticles,
  DefaultCategories,
  NavMovil,
} from "@/Components/Index";
import { useListaCategoria } from "@/Service/Api/Index";
import { ReplaceCharacter } from "@/Utils/RemplaceCharacter";

const LazyHeaderWeb = lazy(() => import("@/Components/Header/HeaderWeb"));
const LazyHeaderMovil = lazy(() => import("@/Components/Header/HeaderMovil"));

const styles = { marginTop: "-8%" };

const ListOfCategorys: React.FC = () => {
  //hooks & screen de pantalla
  const { width } = useWindowsSize();
  //Desabilitamos el zoom a la app.
  useDessableZoom();

  const { listCategory, isLoading } = useListaCategoria();
  let links = "Electrónica";

  //********************** end ************************\\
  const ViewImagesPath = (
    names: string,
    ImagenPath: string,
    actives: boolean
  ): JSX.Element => (
    <div
      className={`card w-100 text-center border-0 develop__borderRadius ${
        actives ? "develop__card" : ""
      }`}>
      <ImagesArticles
        srcx={ImagenPath}
        altx={names}
        classNames={`rounded mx-auto my-auto card-img-top img__develop ${
          actives ? "" : "p-1"
        }`}
        srcDefault={""}
      />
    </div>
  );

  const viewMovil = (
    Category: string,
    subCategory: string,
    ImagenPath: string
  ): JSX.Element => (
    <div
      className={`col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 mt-2 ${
        width < 1202 ? "d-flex justify-content-center" : ""
      }`}
      key={Category.trim()}>
      <div
        className={`d-flex flex-column ${
          width > 700 && width < 1202
            ? "develop__pdre__card"
            : width <= 700
            ? "w-100"
            : ""
        }`}>
        <div className="p-1 shadow mb-1 bg-white develop__borderRadius">
          {subCategory.trim() !== "" ? (
            <Link
              to={`/${links}/${Category.split(" ").join("-")}/${subCategory}`}>
              {ViewImagesPath(subCategory, ImagenPath, true)}
            </Link>
          ) : (
            ViewImagesPath(subCategory, ImagenPath, true)
          )}
        </div>
        <div className="p-1 w-100 text-center">
          <h4 className="develop___ColorText mt-3">
            {ReplaceCharacter(Category)}
          </h4>
        </div>
      </div>
    </div>
  );

  const viewDesktop = (
    Category: string,
    subCategory: string,
    ImagenPath: string
  ): JSX.Element => (
    <div
      className={`${width >= 1500 ? "col-3" : "col-4"} mt-2`}
      key={Category.trim()}>
      <div className="develop__pdre__card__alto">
        <div className="shadow mb-1 bg-white develop__borderRadius">
          {subCategory.trim() ? (
            <Link
              key={subCategory.trim()}
              to={`/${links}/${Category.split(" ").join("-")}/${subCategory}`}>
              {ViewImagesPath(subCategory, ImagenPath, false)}
            </Link>
          ) : (
            ViewImagesPath(subCategory, ImagenPath, false)
          )}
        </div>
        <div className="p-1 w-100 text-center">
          <h4 className="develop___ColorText mt-3">
            {ReplaceCharacter(Category)}
          </h4>
        </div>
      </div>
    </div>
  );

  const skeletonDivButton = (): JSX.Element => (
    <div className="color__develop_skeleton develop__buttons--skeleton p-3 btn_size"></div>
  );

  const handdleBtn = (): JSX.Element => (
    <>
      <div className={`p-${width < 550 ? "1" : "3"}`}>
        {isLoading ? (
          skeletonDivButton()
        ) : (
          <BtnLink
            titlex={"Destacados"}
            classNamex={"ps-btn develop__btns develop___ColorText"}
          />
        )}
      </div>
      <div className={`p-${width < 550 ? "1" : "3"}`}>
        {isLoading ? (
          skeletonDivButton()
        ) : (
          <BtnLink
            titlex={"Ofertas"}
            classNamex={"ps-btn develop__btns develop___ColorText"}
          />
        )}
      </div>
      <div className={`p-${width < 550 ? "1" : "3"}`}>
        {isLoading ? (
          skeletonDivButton()
        ) : (
          <BtnLink titlex={"Categorías"} classNamex={"ps-btn develop__btn"} />
        )}
      </div>
    </>
  );

  const SkeletonInit = (): JSX.Element => {
    return width <= 1200 ? (
      <div className="container mt-5">
        <div className={`row ${width > 700 ? "develop_margin_top700" : ""}`}>
          <DefaultCategories totales={12} />
        </div>
      </div>
    ) : (
      <div className="row">
        <DefaultCategories totales={12} />
      </div>
    );
  };

  return (
    <Suspense>
      {width > 1200 ? (
        <LazyHeaderWeb>
          <HeaderCategoryWeb
            titulo={"Electrónica"}
            toLink={"/"}
            classIcon={"icon-home3 text-white"}
          />
        </LazyHeaderWeb>
      ) : (
        <LazyHeaderMovil isFilter={false}>
          <NavMovil classNames={"aling-self-center"}>
            <HeaderCategoryMovil title={""}>
              <Link to={"/"}>
                <LogoIconNombreSVG />
              </Link>
            </HeaderCategoryMovil>
          </NavMovil>
        </LazyHeaderMovil>
      )}

      <div className="ps-page--shop">
        <div className="ps-container">
          <div className="ps-shopping ps-tab-root">
            <div
              className={`d-flex justify-content-center ${
                width < 500 ? "flex-column" : "mt-3"
              }`}
              style={width < 500 ? styles : {}}>
              {handdleBtn()}
            </div>
            {isLoading ? (
              SkeletonInit()
            ) : (
              <div className={`${width <= 1200 ? "container mt-5" : ""}`}>
                <div
                  className={`row ${
                    width > 700 && width < 1200 ? "develop_margin_top700" : ""
                  }`}>
                  {listCategory?.map((items) =>
                    width < 1202
                      ? viewMovil(
                          items.Category,
                          items.SubCategory.names,
                          items.ImagenPath
                        )
                      : viewDesktop(
                          items.Category,
                          items.SubCategory.names,
                          items.ImagenPath
                        )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default ListOfCategorys;
